// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "Navigator-module--hgwIcon-arrow-down--3s7zt";
export var hgwIconArrowUp = "Navigator-module--hgwIcon-arrow-up--1WYXu";
export var navigator = "Navigator-module--navigator--1qhzb";
export var navigator__toIndex = "Navigator-module--navigator__toIndex--1Gch7";
export var navListItem = "Navigator-module--navListItem--EG3s3";
export var navListItem__aWrap = "Navigator-module--navListItem__aWrap--3W9lw";
export var navListItem__texts__title = "Navigator-module--navListItem__texts__title--2szTX";
export var navListItem__images = "Navigator-module--navListItem__images--2vq2I";
export var navListItem__texts = "Navigator-module--navListItem__texts--33V40";
export var isCurrent = "Navigator-module--isCurrent--3K_9x";
export var navListItem__texts__sub = "Navigator-module--navListItem__texts__sub--Kx6IA";
export var pages = "Navigator-module--pages--3vu1E";
export var navListItem__thumbBox = "Navigator-module--navListItem__thumbBox--1Hj1z";
export var buttonWrap = "Navigator-module--buttonWrap--3c7uX";
export var hideNavigatorButton = "Navigator-module--hideNavigatorButton--1BHw9";
export var animBarTypeA = "Navigator-module--animBarTypeA--3kDu-";
export var animBarTypeB = "Navigator-module--animBarTypeB--2Ec71";
export var animBarTypeC = "Navigator-module--animBarTypeC--fH5qJ";
export var animBarTypeD = "Navigator-module--animBarTypeD--2_2nF";